module.exports = __webpack_public_path__ + "media/images/icons/plus-circle-374a3c4ace20cca1e1b50deb560c98fa.svg";